import { render, staticRenderFns } from "./businessUnitProjects.vue?vue&type=template&id=1e614211&scoped=true&"
import script from "./businessUnitProjects.vue?vue&type=script&lang=js&"
export * from "./businessUnitProjects.vue?vue&type=script&lang=js&"
import style0 from "./businessUnitProjects.vue?vue&type=style&index=0&id=1e614211&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e614211",
  null
  
)

export default component.exports